import { isEmpty } from '../../../utils'

// 组件props 只读/编辑/禁止编辑等
export const shortTextProps = {
  // 值
  value: {
    type: [String, Number],
    default: ''
  },

  // 是否显示tip
  showTooltip: {
    type: Boolean,
    default: true
  },

  // 展示内容
  tip: {
    type: String,
    default: ''
  },

  // 提示语
  placeholder: {
    type: String,
    default: ''
  },

  // 最大长度
  maxLength: {
    type: Number,
    default: 50
  },

  // 行数量
  line: {
    type: Number,
    default: 2
  },

  openDelay: {
    type: Number,
    default: 500
  },

  // 只读
  disabled: {
    type: Boolean,
    default: false
  },

  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  },

  // 是否可清空
  clearable: {
    type: Boolean,
    default: true
  },

  // 自动补全-原生属性
  autocomplete: {
    type: Boolean,
    default: 'off'
  },

  // 自动补全name-原生属性
  name: {
    type: Boolean,
    default: ''
  },

  // 组件尺寸
  size: {
    type: String,
    default: 'small'
  }
}

export function initValue (value) {
  return isEmpty(value) ? '-' : value
}